<template>
  <div class="space-y-3">
    <div class="relative">
      <Search class="pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-[#94a3b8]" />
      <input
        :value="search"
        type="text"
        placeholder="Search clients"
        class="w-full rounded-[0.95rem] border border-[#d3dce9] bg-white py-2.5 pl-10 pr-9 text-[0.92rem] text-[#243049] placeholder-[#94a3b8] outline-none transition focus:border-[#8eb4ff] focus:ring-2 focus:ring-[#cfe0ff]"
        @input="$emit('update:search', ($event.target as HTMLInputElement).value)"
      >
      <button
        v-if="search"
        type="button"
        class="absolute right-3 top-1/2 -translate-y-1/2 text-[#94a3b8] hover:text-[#475569]"
        title="Clear search"
        @click="$emit('update:search', '')"
      >
        <X class="h-4 w-4" />
      </button>
    </div>

    <div class="grid grid-cols-2 gap-2">
      <select
        :value="statusFilter"
        class="compact-select"
        @change="$emit('update:status-filter', ($event.target as HTMLSelectElement).value)"
      >
        <option value="all">
          All Statuses
        </option>
        <option value="none">
          No Reports
        </option>
        <option value="partial">
          Partially Ready
        </option>
        <option value="full">
          Fully Ready
        </option>
      </select>

      <select
        v-if="showServiceFilter"
        :value="serviceFilter"
        class="compact-select"
        @change="$emit('update:service-filter', ($event.target as HTMLSelectElement).value)"
      >
        <option value="">
          All Packages
        </option>
        <option
          v-for="option in serviceOptions"
          :key="option"
          :value="option"
        >
          {{ option }}
        </option>
      </select>

      <div
        v-else
        class="hidden"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Search, X } from "lucide-vue-next";

defineProps<{
  search: string;
  statusFilter: string;
  serviceFilter: string;
  serviceOptions: string[];
  showServiceFilter: boolean;
}>();

defineEmits<{
  (event: "update:search", value: string): void;
  (event: "update:status-filter", value: string): void;
  (event: "update:service-filter", value: string): void;
}>();
</script>

<style scoped>
.compact-select {
  width: 100%;
  border-radius: 0.95rem;
  border: 1px solid #d3dce9;
  background-color: white;
  padding: 0.6rem 0.75rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: #243049;
  outline: none;
  cursor: pointer;
  transition: all 0.15s ease;
}

.compact-select:focus {
  border-color: #8eb4ff;
  box-shadow: 0 0 0 2px #cfe0ff;
}
</style>
